const hoursToMilliseconds = (hrs) => (hrs * 60 * 60 * 1000);

export { hoursToMilliseconds };
